module.exports = __webpack_public_path__ + "static/media/multi_samples_animation.40c564d7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/multi_samples_animation.gif
// module id = 1738
// module chunks = 68